export default __webpack_public_path__ + "static/media/hero.805a023c.png";